import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { updateBreadCrumbs } from '../../redux/Actions/BreadCrumbs/ActionCreators';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

class NotFound extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);

    this.click = this.click.bind(this);
  }

  public componentDidMount() {
    const items: IBreadcrumbItem[] = [{ text: 'Home', key: '/home' }, { text: 'Not Found', key: '/', isCurrentItem: true }];

    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    return (
      <Fabric className="ms-Grid">
        <div className="ms-Grid-row">
          <Spinner size={SpinnerSize.large} label="Not implemented yet..." ariaLive="assertive" />
        </div>
      </Fabric>
    );
  }

  private click(): void {
    const items: IBreadcrumbItem[] = [{ text: 'Home', key: '/home' }, { text: 'Not Found', key: '/', isCurrentItem: true }];

    this.props.updateBreadCrumbs(items);
  }
}

export default connect(
  null,
  mapDispatchToProps
)(NotFound);
